<template>
  <div>
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="$t('tOrderDetail')"
      ></el-page-header>
    </div>
    <el-card class="content mt20 bbb">
      <el-form
        label-position="left"
        :model="ruleForm"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('orderList.status')" prop="status">
          <div>{{ status(ruleForm.status) }}</div>
        </el-form-item>
        <el-form-item :label="$t('orderList.merchant_uid')" prop="merchant_uid">
          <div>{{ ruleForm.merchant_uid }}</div>
        </el-form-item>
        <el-form-item :label="$t('orderList.username')" prop="username">
          <div>{{ ruleForm.username }}</div>
        </el-form-item>
        <el-form-item :label="$t('orderList.real_name')" prop="real_name">
          <div>{{ ruleForm.real_name }}</div>
        </el-form-item>
        <el-form-item :label="$t('orderList.user_gender')" prop="user_gender">
          <div>{{ user_gender(ruleForm.user_gender) }}</div>
        </el-form-item>
        <el-form-item :label="$t('orderList.user_phone')" prop="user_phone">
          <div>{{ ruleForm.user_phone }}</div>
        </el-form-item>
        <el-form-item :label="$t('orderList.title')" prop="title">
          <div>
            {{
              ruleForm.type === 0
                ? ruleForm.club_title
                : ruleForm.activity_title
            }}
          </div>
        </el-form-item>
        <el-form-item :label="$t('orderList.type')" prop="type">
          <div>
            {{
              ruleForm.type === 0
                ? club_type(ruleForm.club_type)
                : activity_type(ruleForm.activity_type)
            }}
          </div>
        </el-form-item>
        <el-form-item :label="$t('orderList.pay_method')" prop="pay_method">
          <div>{{ pay_method(ruleForm.pay_method) }}</div>
        </el-form-item>
        <el-form-item :label="$t('orderList.price')" prop="price">
          <div>{{ ruleForm.price }}</div>
        </el-form-item>
        <el-form-item :label="$t('orderList.discount')" prop="discount">
          <div>{{ ruleForm.discount }}</div>
        </el-form-item>
        <el-form-item :label="$t('orderList.pay_amount')" prop="pay_amount">
          <div>{{ ruleForm.pay_amount }}</div>
        </el-form-item>
        <el-form-item :label="$t('orderList.pay_time')" prop="pay_time">
          <div>{{ time.formatTime(ruleForm.pay_time * 1000) }}</div>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import time from '@/utils/timeFormat';
import { orderDetail } from '@/api/api';
export default {
  name: 'orderDetail',
  data() {
    return {
      time,
      ruleForm: {},
    };
  },
  computed: {
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    },
  },
  methods: {
    pay_method(pay_method) {
      switch (pay_method) {
        case 'card':
          return this.$t('orderList.pay_method0');
        case 'trans':
          return this.$t('orderList.pay_method1');
        case 'phone':
          return this.$t('orderList.pay_method2');
        case 'coupon':
          return this.$t('orderList.pay_method3');
        case 'naverpay':
          return this.$t('orderList.pay_method4');
      }
    },
    activity_type(activity_type) {
      switch (activity_type) {
        case '1':
          return this.$t('orderList.activity_type2');
        case '2':
          return this.$t('orderList.activity_type1');
      }
    },
    club_type(club_type) {
      switch (club_type) {
        case 0:
          return this.$t('orderList.club_type0');
        case 1:
          return this.$t('orderList.club_type1');
      }
    },
    user_gender(user_gender) {
      switch (user_gender) {
        case 0:
          return this.$t('orderList.user_gender0');
        case 1:
          return this.$t('orderList.user_gender1');
        case 2:
          return this.$t('orderList.user_gender2');
      }
    },
    status(status) {
      switch (status) {
        case 0:
          return this.$t('orderList.status0');
        case 1:
          return this.$t('orderList.status1');
        case 2:
          return this.$t('orderList.status2');
        case 3:
          return this.$t('orderList.status3');
      }
    },
    async get_info() {
      const information = await orderDetail(this.id);
      this.ruleForm = { ...information };
    },
  },
  async created() {
    if (this.id === undefined) return;
    this.get_info();
  },
};
</script>
<style land="scss" scoped>
.el-date-editor {
  margin-right: 10px;
}
.bbb {
  position: relative;
  padding-bottom: 50px;
}
.bbb .btn {
  position: absolute;
  bottom: 10px;
  right: 20px;
}
</style>
